export default "__VITE_ASSET__Cdrdyeez__"